export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9100.0c6cc3db.jpg";